import * as React from "react";
import Popover from "@mui/material/Popover";
import { Close, ArrowDropUp, ArrowDropDown } from '@material-ui/icons'
import IconCheck from "@material-ui/icons/Check";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
const useStyles = makeStyles((theme) => ({
  paper: {

    background: "var(--backgroundcolor)",
    color: "white"
  }
}))
function valuetext(value) {
  return `${value} Baggage`;
}




export default function Baggages(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const bagOptions = { "0": 'No', "1": '1', "2": '2'}


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleHandBagChange =(val)=>{
    handleChange({hand_bag:val,hold_bag:props.value.hold_bag})
  }

  const handleHoldBagChange =(val)=>{
    handleChange({hand_bag:props.value.hand_bag,hold_bag:val})
  }

  const handleChange = (val) => {
    if (props.onChange)
      props.onChange(val)
  }
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClear = (e) => {
    e.stopPropagation()
    handleChange(props.defaultValue)
    handleReset()
  }
  const handleReset = () => {
    if (props.onReset)
      props.onReset();
  }

  return (
    <div>
       <div className='filter-button' onClick={handleClick}>
      <Typography component="span"  className="filter-text">  
      
     {props.used&&bagOptions[props.value.hand_bag]!="No"&&<>{bagOptions[props.value.hand_bag]}  <Typography component="span" style={{color:'var(--darker)',fontSize:'10px'}}> Cabin Bag </Typography>
     </>}
     {props.used&&bagOptions[props.value.hold_bag]!="No"&&<>{bagOptions[props.value.hold_bag]}  <Typography component="span" style={{color:'var(--darker)',fontSize:'10px'}}> Checked Bag </Typography>
     </>}
     {!props.used&&'Bags'}
      </Typography>
        <Typography variant="span" className="filter-arrow">
          {open ? <ArrowDropUp /> : <ArrowDropDown />}
        </Typography>
        {props.used ? <Typography className="icon-close" variant="a" style={{ fontSize: '18px' }} onClick={handleClear}><Close /></Typography> : ""}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >

        <div className="bag-option-box" style={{ width: '300px', padding: '10px',backgroundColor:'var(--backgroundcolor)',borderRadius:'5px' }}>
          <Grid container>
            <Grid item xs="12" md="6">
            <FormControl fullWidth size="sm">
            <Typography component="p" style={{textAlign:'left',color:'var(--darker)'}}>Cabin Bags</Typography>
           
            <Select
              fullWidth              
               MenuProps={{
                classes: {
                  paper: classes.paper
                }
              }}
              disableUnderline
              style={{ height: "100%" }}
               value={props.value.hand_bag}
              onChange={(e) => {
                 handleHandBagChange(  e.target.value );
              }}
            >
              {Object.keys(bagOptions).map((item) => (
                <MenuItem value={item}>{bagOptions[item]}</MenuItem>
              ))}
            </Select>
          </FormControl>
           </Grid>
           <Grid item xs="12" md="6">
            <FormControl fullWidth size="sm">
            <Typography component="p" style={{textAlign:'left',color:'var(--darker)'}}>Checked Bags</Typography>
           
            <Select
              fullWidth
              
               MenuProps={{
                classes: {
                  paper: classes.paper
                }
              }}
              disableUnderline
              style={{ height: "100%" }}
               value={props.value.hold_bag}
              onChange={(e) => {
                 handleHoldBagChange(  e.target.value );
              }}
            >
              {Object.keys(bagOptions).map((item) => (
                <MenuItem value={item}>{bagOptions[item]}</MenuItem>
              ))}
            </Select>
          </FormControl>
           </Grid>
           </Grid>
        </div>

      </Popover>
    </div>
  );
}

Baggages.defaultProps = {
 value:{ hold_bag: '0',
  hand_bag:'0'}
}
